export default __webpack_public_path__ + "static/media/joost.8a9a6ad6.png";